// ── SMS PARSER ────────────────────────────────────────────────────────────────
export function parseSMS(raw, bank) {
  const text = raw || '';
  let amount = null, direction = 'debit', description = '', date = null, balance = null, currency = 'AED';

  // Amount + currency + direction marker
  const amtMatch = text.match(/([A-Z]{3})\s+([\d,]+\.?\d*)([-+])?/);
  if (amtMatch) {
    currency  = amtMatch[1];
    amount    = parseFloat(amtMatch[2].replace(/,/g, ''));
    if (amtMatch[3] === '-') direction = 'debit';
    if (amtMatch[3] === '+') direction = 'credit';
  }

  // HSBC Credit Card: "has been used for AED X on DD/MM/YYYY at MERCHANT."
  const hsbcCard = text.match(/has been used for [A-Z]{3} [\d,.]+ on (\d{2}\/\d{2}\/\d{4}).+? at (.+?)\./);
  if (hsbcCard) { date = hsbcCard[1]; description = hsbcCard[2].trim(); direction = 'debit'; }

  // HSBC Account: "DD/MM/YYYY description AED X-"
  const hsbcAcct = text.match(/^(\d{2}\/\d{2}\/\d{4})\s+(.+?)\s+[A-Z]{3}/);
  if (hsbcAcct && !date) { date = hsbcAcct[1]; description = hsbcAcct[2].trim(); }

  // Generic card: date + "at MERCHANT"
  const generic = text.match(/(\d{2}\/\d{2}\/\d{4}).*? at (.+?)[\.,]/);
  if (generic && !date) { date = generic[1]; description = generic[2].trim(); }

  // Balance
  const balMatch = text.match(/(?:available (?:limit|balance) is) [A-Z]{3} ([\d,]+\.?\d*)/i);
  if (balMatch) balance = parseFloat(balMatch[1].replace(/,/g, ''));

  // Fallback date
  if (!date) { const dm = text.match(/(\d{2}\/\d{2}\/\d{4})/); if (dm) date = dm[1]; }

  // Fallback description
  if (!description) description = text.replace(/[A-Z]{3}\s[\d,.]+-?/g, '').replace(/\s+/g, ' ').trim().slice(0, 80);

  // Card last 4
  const cardMatch = text.match(/ending (?:with )?\*{2,3}(\d{4})/i);
  const account_last4 = cardMatch ? cardMatch[1] : bank.split('-').pop();

  return { amount, direction, description, date, balance, currency, account_last4 };
}

// Extract latest balance per account from SMS log
export function extractLatestBalances(smsLog) {
  const balances = {};
  const sorted = [...smsLog].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  for (const sms of sorted) {
    if (!sms.bank || balances[sms.bank] !== undefined) continue;
    const match = sms.body?.match(/(?:available (?:limit|balance) is) ([A-Z]{3}) ([\d,]+\.?\d*)/i);
    if (match) balances[sms.bank] = { currency: match[1], amount: parseFloat(match[2].replace(/,/g, '')), timestamp: sms.timestamp };
  }
  return balances;
}
